import React from 'react';

import 'style/layout/BasicFormContainer.css';

const BasicFormContainer = ({
  children,
  className,
}: {
  // Also the parts shown only on a condition (null or undefined when not)
  children: React.ReactNode;
  className?: string;
}): JSX.Element => (
  <div
    className={
      className ? `basic-form-container ${className}` : 'basic-form-container'
    }
  >
    {children}
  </div>
);

export default BasicFormContainer;
